module.exports = __webpack_public_path__ + "static/media/homepage_house2.cf054770.png";